import {
  SET_CNPJ,
} from './mutations.type';

export default {
  [SET_CNPJ](state, cnpj) {
    state.cnpj = cnpj;
  },
};
